import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';

class SignIn extends Component {

    state = {
        email: ''
    }
    
    submit = (e) => {
        e.preventDefault();
        const { forgot } = this.props;
        forgot(this.state, this.resetEmail);
    }

    onChange = (e) => {
        const { name, value } = e.target;
        const nextState = {};
        nextState[name] = value;
        this.setState(nextState);
    }

    resetEmail = () => {
        this.setState({
            email: ''
        })
    }

    render(){

        return (
            <div className="main-content">
                <div className="row">

                    <div className="col-md-12 home">
                        <h1>Forgot Password</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-custom">
                            <div className="panel-body">
                                <form onSubmit={ this.submit }>
                                    <div className="form-group">
                                        <label>Email address</label>
                                        <input 
                                            value={this.state.email}
                                            type="text" 
                                            name="email" 
                                            className="form-control form-custom" 
                                            onChange={this.onChange}/>
                                    </div>
                                    
                                    <div className="btn-custom">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary"
                                            disabled={this.props.isWaiting}>
                                            { this.props.isWaiting
                                                ? 'Loading...'
                                                : 'Submit'
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => {
        const { isWaiting } = state.onWaiting;
        
        return {
            isWaiting
        }
    },
    actions
)(SignIn)


// WEBPACK FOOTER //
// ./src/sign-in/containers/Forgot.js